import PharmacyAdmin from "./Pharmacies";
export default PharmacyAdmin;
